import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {BottomNavigationBarContainerBox} from "./boxes/container/bottom-navigation-bar-container.box";
import {BottomNavigationBarMenuItemsListComponent} from "./bottom-navigation-bar-menu-items-list.component";
import {CyClass} from "../../../common/cy-classes";
import classNames from 'classnames';
import {HYBRID_EMBEDDED_NAV_MENU} from "./bottom-navigation-bar-consts";

export const BottomNavigationBarComponent = observer(class StickyNavigationMenuComponent extends OrbitComponent<{}> {

  render() {

    if (!this.services.device.hybrid.isHybrid) {
        return null;
    }

    if (!this.services.mediaQuery.lAndBelow) {
        return null;
    }


    return(
      <BottomNavigationBarContainerBox shouldElevate={this.services.spinner.isSpinning}
                                       className={classNames(HYBRID_EMBEDDED_NAV_MENU, CyClass('cy-hybrid-embedded-nav-menu'))}>
        <BottomNavigationBarMenuItemsListComponent />
      </BottomNavigationBarContainerBox>
    );
  }
});
